import * as React from 'react';
import '../../../../../aside_panel/cardDetails/ColorTags/components/CardColorTags/_CardColorTags.scss';
import { SectionAccordion, SelectList } from 'kui';
import { IColorTag } from '../../../../../../../types/types';
import {
    CardColorTagItem
} from '../../../../../aside_panel/cardDetails/ColorTags/components/CardColorTagItem/CardColorTagItem';
import { IColorTagSelectProps } from './types';
import './_ColorTagsSelects.scss';
import { CLASS_COLOR_TAGS_DROPDOWN, MIN_WIDTH_FOR_3_COLUMNS } from '../../constants';

export function ColorTagsSelect({
    asidePanelWidth,
    checkedColors = [],
    colors,
    disableAll,
    isHideTitle,
    isSmall,
    opened,
    title,
    onChange,
    onClick,
    onOpen,
    onSelect
}: IColorTagSelectProps) {
    const isWide = asidePanelWidth > MIN_WIDTH_FOR_3_COLUMNS;
    const className = CLASS_COLOR_TAGS_DROPDOWN + '-select';
    const classColumns = className + '__columns';
    const classColumn = isWide && !isSmall ? className + '__column--wide' : className + '__column';

    const columnCount = isWide ? 3 : 2;
    let columns: any = [];
    let remainder = colors.length % columnCount;
    let index = 0;
    for (let i = 0; i < columnCount; i++) {
        const columnSize = Math.floor(colors.length / columnCount) + (remainder-- > 0 ? 1 : 0);
        columns[i] = colors.slice(index, index + columnSize);
        index += columnSize;
    }

    const boardColorsColumn = (colors: IColorTag[]): JSX.Element[] => {
        if (!colors.length) return null;
        const colorTagsIds = checkedColors.map(tag => tag.id);

        return colors.map((item) => {
            const isChecked = colorTagsIds.includes(item.id);
            const isDisabled = !isChecked && disableAll;
            return (
                <CardColorTagItem
                    isChecked={isChecked}
                    isDisabled={isDisabled}
                    item={item}
                    key={item.id}
                    onChange={onChange}
                    onSelect={onSelect}
                />
            );
        });
    };

    const body = <div
        className={`
            ${classColumns}
            ${classColumns + '--no-title'}
            ${isWide ? classColumns + '--wide' : ''}
        `}
    >
        <SelectList
            className={classColumn}
            fixActive={false}
        >
            {boardColorsColumn(columns[0])}
        </SelectList>
        {!!columns[1].length &&
            <SelectList
                className={classColumn}
                fixActive={false}
            >
                {boardColorsColumn(columns[1])}
            </SelectList>
        }
        {isWide && !!columns[2].length &&
            <SelectList
                className={classColumn}
                fixActive={false}
            >
                {boardColorsColumn(columns[2])}
            </SelectList>
        }
    </div>;

    return (
        <>
            {isHideTitle ?
                body
                : <SectionAccordion
                    className={className + '__section'}
                    variant={'simple'}
                    title={title}
                    opened={opened}
                    onOpen={() => {
                        if (onOpen) onOpen();
                        onClick();
                    }}
                    onClose={onClick}
                >
                    {body}
                </SectionAccordion>
            }
        </>
    );
};
